import React from "react";
import {
  Page,
  Text,
  Image,
  Document,
  StyleSheet,
  View,
} from "@react-pdf/renderer";

// Exemple de logo en base64 (à remplacer par le tien)
const logoBase64 = "data:image/png;base64,iVBORw0K...";

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    paddingTop: 40,
    paddingBottom: 60,
    paddingHorizontal: 40,
    fontSize: 12,
    lineHeight: 1.5,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 24,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    paddingBottom: 10,
  },
  logo: {
    width: 50,
    height: 50,
  },
  title: {
    fontSize: 20,
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
    flexGrow: 1,
    marginTop: 10,
  },
  headerText: {
    fontSize: 8,
    marginBottom: 3,
    textAlign: "right",
  },
  section: {
    marginBottom: 20,
  },
  questionTitle: {
    fontSize: 14,
    fontFamily: "Helvetica-Bold",
    marginBottom: 5,
  },
  text: {
    fontSize: 12,
    marginBottom: 5,
  },
});

const MyDocument = ({ report, userLang }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* Header */}
      <View style={styles.header}>
        <Image style={styles.logo} src={logoBase64} />
        <Text style={styles.title}>
          {userLang === "EN" ? report?.titleRepportEn : report?.titleRepportFr}
        </Text>
        <View>
          <Text style={styles.headerText}>Date: {report?.dateComplete}</Text>
          <Text style={styles.headerText}>
            Restaurant: {report?.nomEmplacement}
          </Text>
          <Text style={styles.headerText}>Author: {report?.username}</Text>
        </View>
      </View>

      {/* Questions and Responses */}
      {report?.listeQuestions?.map((q) => (
        <View key={q.id} style={styles.section}>
          <Text style={styles.questionTitle}>
            {userLang === "EN" ? q.textEn : q.textFr}
          </Text>

          {report?.listeReponses
            ?.filter((rep) => rep && rep.idQuestion === q.id)
            .map((rep) => (
              <Text key={rep.id} style={styles.text}>
                {rep.commentaire || "No comment"}
              </Text>
            ))}

          {/* Sub-questions */}
          {q.childQuestions?.map((qc) => (
            <View key={qc.id} style={{ marginTop: 10 }}>
              <Text style={styles.questionTitle}>
                {userLang === "EN" ? qc.textEn : qc.textFr}
              </Text>
              {report?.listeReponses
                ?.filter((rep) => rep && rep.idQuestion === qc.id)
                .map((rep) => (
                  <Text key={rep.id} style={styles.text}>
                    {rep.commentaire || "No comment"}
                  </Text>
                ))}
            </View>
          ))}
        </View>
      ))}
    </Page>
  </Document>
);

export default MyDocument;
